export const mixFilters = {
  props: {
    eventID: { type: String, required: true },
    place: { type: String, default: 'column' }
  },
  data () {
    return {
      isLoading: false,
      options: null,
      valueTemplate: null, // TODO Need delete
      result: '',
      resultHuman: ''
    }
  },
  created () {
    this.$bus.$on(`on-set-filter-${this.eventID}`, this.handleSetFilterValue)
  },
  beforeDestroy () {
    this.$bus.$off(`on-set-filter-${this.eventID}`, this.handleSetFilterValue)
  },
  mounted () {
    this.handle('mounted')
  },
  computed: {
    fieldLabel () {
      return this.checkEs6AndRun(this.config.label)
    },
    createValue () {
      return this.createValueTemplate(this.options.valueTemplate)
    }
  },
  methods: {
    ModelConfig () {
      throw Error('Required filter interface')
    },
    parseConfig () {
      throw Error('Required filter interface')
    },
    handle (Type) {
      this.$emit('handle', {
        id: this.config.id,
        type: Type,
        value: this.result,
        rendered: this.resultHuman
      })
    },
    createValueTemplate (Template) {
      if (typeof Template === 'function') {
        return Template
      } else {
        // eslint-disable-next-line
        return new Function('data, root', `return \`${Template}\``)
      }
    },
    handleSetFilterValue (value) {
      this.handleChange(value)
    }
  }
}
